export class Cliente {
  private apelido:      string;
  private bairro:       string;
  private celular:      string;
  private cep:          string;
  private cod_prop:     number;
  private codigo:       string;
  private colaborador:  number;
  private contato:      string;
  private cpl_end:      string;
  private data_inc:     string;
  private data_nasc:    string;
  private data_rg:      string;
  private dia_fat:      number;
  private email:        string;
  private endereco:     string;
  private env_email:    string;
  private ie:           string;
  private ind_ie:       string;
  private limite:       number;
  private municipio:    number;
  private nome:         string;
  private nome_mae:     string;
  private nome_pai:     string;
  private nro_doc:      string;
  private nro_end:      string;
  private nro_rg:       string;
  private orgao_emi_rg: string;
  private ponto_ref:    string;
  private script:       string;
  private sexo:         string;
  private status:       string;
  private telefone:     string;
  private tipo_cli:     number;
  private uf_emi_rg:    string;
  private nome_cid:     string;

  constructor(private c_proprietario, private c_colaborador) {
    this.colaborador = c_proprietario;
    this.cod_prop    = c_colaborador;
  }

  public toJSON() {
    return {
      apelido:      this.apelido,
      bairro:       this.bairro,
      celular:      this.celular,
      cep:          this.cep,
      cod_prop:     this.cod_prop,
      codigo:       this.codigo,
      colaborador:  this.colaborador,
      contato:      this.contato,
      cpl_end:      this.cpl_end,
      data_inc:     this.data_inc,
      data_nasc:    this.data_nasc,
      data_rg:      this.data_rg,
      dia_fat:      this.dia_fat,
      email:        this.email,
      endereco:     this.endereco,
      env_email:    this.env_email,
      ie:           this.ie,
      ind_ie:       this.ind_ie,
      limite:       this.limite,
      municipio:    this.municipio,
      nome:         this.nome,
      nome_mae:     this.nome_mae,
      nome_pai:     this.nome_pai,
      nro_doc:      this.nro_doc,
      nro_end:      this.nro_end,
      nro_rg:       this.nro_rg,
      orgao_emi_rg: this.orgao_emi_rg,
      ponto_ref:    this.ponto_ref,
      script:       this.script,
      sexo:         this.sexo,
      status:       this.status,
      telefone:     this.telefone,
      tipo_cli:     this.tipo_cli,
      uf_emi_rg:    this.uf_emi_rg,
      nome_cid:     this.nome_cid
    };
  }

  public toClass(cliente) {
    this.apelido      = cliente.apelido;
    this.bairro       = cliente.bairro;
    this.celular      = cliente.celular;
    this.cep          = cliente.cep;
    this.cod_prop     = cliente.cod_prop;
    this.codigo       = cliente.codigo;
    this.colaborador  = cliente.colaborador;
    this.contato      = cliente.contato;
    this.cpl_end      = cliente.cpl_end;
    this.data_inc     = cliente.data_inc;
    this.data_nasc    = cliente.data_nasc;
    this.data_rg      = cliente.data_rg;
    this.dia_fat      = cliente.dia_fat;
    this.email        = cliente.email;
    this.endereco     = cliente.endereco;
    this.env_email    = cliente.env_email;
    this.ie           = cliente.ie;
    this.ind_ie       = cliente.ind_ie;
    this.limite       = cliente.limite;
    this.municipio    = cliente.municipio;
    this.nome         = cliente.nome;
    this.nome_mae     = cliente.nome_mae;
    this.nome_pai     = cliente.nome_pai;
    this.nro_doc      = cliente.nro_doc;
    this.nro_end      = cliente.nro_end;
    this.nro_rg       = cliente.nro_rg;
    this.orgao_emi_rg = cliente.orgao_emi_rg;
    this.ponto_ref    = cliente.ponto_ref;
    this.script       = cliente.script;
    this.sexo         = cliente.sexo;
    this.status       = cliente.status;
    this.telefone     = cliente.telefone;
    this.tipo_cli     = cliente.tipo_cli;
    this.uf_emi_rg    = cliente.uf_emi_rg;
    this.nome_cid     = cliente.nome_cid;
  }
}
